import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

function* createMemberFilter() {
  yield takeEvery(actions.CREATE_MEMBER_FILTER, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${API_HOST}/api/memberFilter`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_MEMBER_FILTER_ENDED });
    }
  });
}

function* searchMemberFilters() {
  yield takeEvery(actions.SEARCH_MEMBER_FILTERS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/memberFilter?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_MEMBER_FILTERS_ENDED });
    }
  });
}

function* findMemberFilter() {
  yield takeEvery(actions.FIND_MEMBER_FILTER, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/memberFilter/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.FIND_MEMBER_FILTER_ENDED });
    }
  });
}

function* updateMemberFilter() {
  yield takeEvery(actions.UPDATE_MEMBER_FILTER, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_HOST}/api/memberFilter`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_MEMBER_FILTER_ENDED });
    }
  });
}

function* deleteMemberFilters() {
  yield takeEvery(actions.DELETE_MEMBER_FILTERS, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${API_HOST}/api/memberFilter`, { data });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_MEMBER_FILTERS_ENDED });
    }
  });
}

function* triggerMemberFilters() {
  yield takeEvery(actions.TRIGGER_MEMBER_FILTERS, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${API_HOST}/api/memberFilter/${id}/trigger`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.TRIGGER_MEMBER_FILTERS_ENDED });
    }
  });
}

function* getMemberFilterTriggerRecordStatistics() {
  yield takeEvery(actions.GET_MEMBER_FILTER_TRIGGER_RECORD_STATISTICS, function* (action) {
    const { memberFilterId, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/memberFilter/${memberFilterId}/record/statistics`,
        { timeout: 300000 }, // 5 minute
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_MEMBER_FILTER_TRIGGER_RECORD_STATISTICS_ENDED });
    }
  });
}

function* searchTriggerRecords() {
  yield takeEvery(actions.SEARCH_MEMBER_FILTER_TRIGGER_RECORDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/memberFilter/triggerRecord?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_MEMBER_FILTER_TRIGGER_RECORDS_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createMemberFilter),
    fork(searchMemberFilters),
    fork(findMemberFilter),
    fork(updateMemberFilter),
    fork(deleteMemberFilters),
    fork(triggerMemberFilters),
    fork(getMemberFilterTriggerRecordStatistics),
    fork(searchTriggerRecords),
  ]);
}
